import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ConfirmationContainer from '../container-confirmation';
const ConfirmationCallbackPage = _ref => {
  let {
    confirmationToken
  } = _ref;
  return /*#__PURE__*/React.createElement(ConfirmationContainer, {
    confirmationToken: confirmationToken
  });
};
const mapStateToProps = _ref2 => {
  let {
    user
  } = _ref2;
  return {
    confirmationToken: user.confirmationToken
  };
};
ConfirmationCallbackPage.propTypes = {
  // TODO: useful ?
  // decodedIdToken: PropTypes.shape({
  //   [`${window.processRuntime.env?.AUTH0_CUSTOM_CLAIMS_DOMAIN}/app_metadata`]: PropTypes.shape({
  //     justSignedUp: PropTypes.bool.isRequired
  //   }).isRequired
  // }).isRequired,
  confirmationToken: PropTypes.string.isRequired
};
export default connect(mapStateToProps, null)(ConfirmationCallbackPage);